/** @file /settings: general, keyboard shortcuts, API tokens with client setup, and password sections. */
import { detectPlatform } from '@pose2d/shortcuts/detectPlatform';
import { useStore } from 'zustand';
import { api } from '../api/api';
import { settingsApi } from '../api/settingsApi';
import { useT } from '../shell/i18n/useT';
import { updateUiSettings } from '../shell/settings/updateUiSettings';
import { allBindings } from '../shell/shortcuts/allBindings';
import { ShellHeader } from '../shell/ShellHeader';
import { settingsStore } from '../stores/settingsStore';
import { GeneralSection } from './settings/GeneralSection';
import { pageOrigin } from './settings/pageOrigin';
import { PasswordSection } from './settings/PasswordSection';
import { ShortcutsSection } from './settings/ShortcutsSection';
import { TokensSection } from './settings/TokensSection';
import './settings/settings.css';

const DEFAULTS = allBindings();
const PLATFORM = detectPlatform(globalThis.navigator);
const copyText = (text: string): Promise<void> => navigator.clipboard.writeText(text);

/** Every section saves on its own and shows its own failure. */
export function SettingsScreen() {
  const t = useT();
  const shortcuts = useStore(settingsStore, (s) => s.shortcuts);
  return (
    <main className="shell-page">
      <ShellHeader t={t} title={t('settings.title')} />
      <div className="settings-sections">
        <GeneralSection t={t} />
        <ShortcutsSection t={t} defaults={DEFAULTS} overrides={shortcuts} platform={PLATFORM} save={(next) => updateUiSettings(api, { shortcuts: next })} />
        <TokensSection t={t} client={settingsApi} origin={pageOrigin()} copy={copyText} />
        <PasswordSection t={t} client={settingsApi} />
      </div>
    </main>
  );
}
